/**
 * The backend (ELSCI_GET_LICENSE_STATUS) reports only status/source/exp/reason - it never computes daysLeft or
 * an EXPIRING_SOON status, since those are presentation concerns. This derives them client-side.
 */
export default class LicenseUtils {
	static DEFAULT_WARN_WITHIN_DAYS = 14;

	/** @returns {?number} signed whole days until the ISO timestamp (negative = already past), or null if unparseable */
	static daysLeft(isoString) {
		if (!isoString)
			return null;
		const date = new Date(isoString);
		if (isNaN(date.getTime()))
			return null;
		return Math.trunc((date.getTime() - Date.now()) / 86400000);
	}

	/**
	 * Augments the backend's expiry status with a client-computed `daysLeft`, and upgrades an 'OK' status to
	 * 'EXPIRING_SOON' when the license expires within `warnWithinDays`.
	 * @param {{status: string, source?: string, exp?: string, reason?: string}} expiry
	 * @param {number} warnWithinDays
	 * @returns {{status: string, source?: string, exp?: string, daysLeft?: number, reason?: string}}
	 */
	static deriveExpiry(expiry, warnWithinDays = LicenseUtils.DEFAULT_WARN_WITHIN_DAYS) {
		const daysLeft = LicenseUtils.daysLeft(expiry.exp);
		const status = expiry.status === 'OK' && daysLeft !== null && daysLeft <= warnWithinDays
			? 'EXPIRING_SOON'
			: expiry.status;
		return daysLeft === null ? {...expiry, status} : {...expiry, status, daysLeft};
	}
}
